import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { IDialog } from '@shared/components/dialog/dialog.service';

export interface InputDialogData {
  value?: string;
  title: string;
  message: string;
  formErrorMessage: string;
  label: string;
  validator?: (control: AbstractControl) => ValidationErrors | null;
}

@Component({
  selector: 'recrewt-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss'],
  standalone: false,
})
export class InputDialogComponent implements OnInit, IDialog {
  private formBuilder = inject(UntypedFormBuilder);
  private dialogRef = inject<MatDialogRef<InputDialogComponent>>(MatDialogRef);
  data = inject<InputDialogData>(MAT_DIALOG_DATA);

  form!: UntypedFormGroup;

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit(): void {
    const { value, valid } = this.form;
    if (valid) {
      this.dialogRef.close(value.name);
    }
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: [this.data.value, [Validators.required, this.data.validator ?? Validators.required]],
    });
  }
}
